// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"ExpandableContent-c5ade3ffc58e8127","button":"ExpandableContent-22de1c220263ef34"};